export default __webpack_public_path__ + "a3d85e1dd6dae9e33ef6e110d13bb881.png";